var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserService } from "../../services/user.service";
import { EduComponent } from "../../utils/eduComponent";
import Utils from "../../utils/utils";
var SimplifiedFooterComponent = /** @class */ (function (_super) {
    __extends(SimplifiedFooterComponent, _super);
    function SimplifiedFooterComponent(userService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.gtmPrefix = "gtm-footer-";
        return _this;
    }
    SimplifiedFooterComponent.prototype.ngOnInit = function () {
        this.isStudent = this.userService.hasStudentExperience();
        this.currentYear = Utils.getCurrentYear();
        this.pbsLogoWhite = require("../../../assets/PBS-logo-white.svg");
    };
    return SimplifiedFooterComponent;
}(EduComponent));
export { SimplifiedFooterComponent };
